// extracted by mini-css-extract-plugin
module.exports = {"item":"ItemBlock_item_1dPWg","inner":"ItemBlock_inner_2Qs1G","menu":"ItemBlock_menu_2DZwe"};